import { Component } from '@angular/core';

@Component({
  selector: 'app-logged-out',
  templateUrl: './logged-out.component.html',
  styleUrls: ['./logged-out.component.scss'],
  standalone: false,
})
export class LoggedOutComponent {
  constructor() {}
}
